var map = {
	"./Ansar.svg": [
		29239,
		29239
	],
	"./Ayandeh.svg": [
		71600,
		71600
	],
	"./Bank_Markazi.svg": [
		86434,
		86434
	],
	"./Caspian.svg": [
		29717,
		29717
	],
	"./Default.svg": [
		11889,
		11889
	],
	"./Dey.svg": [
		26280,
		26280
	],
	"./Eghtesad_Novin.svg": [
		34628,
		34628
	],
	"./Futurebank.svg": [
		59877,
		59877
	],
	"./Gardeshgari.svg": [
		72063,
		72063
	],
	"./Ghavamin.svg": [
		64537,
		64537
	],
	"./Hekmat.svg": [
		10840,
		10840
	],
	"./Iran_Europe.svg": [
		28447,
		28447
	],
	"./Iran_Venezuela.svg": [
		54518,
		54518
	],
	"./Iran_Zamin.svg": [
		40878,
		40878
	],
	"./Karafarin.svg": [
		46925,
		46925
	],
	"./Keshavarzi.svg": [
		71644,
		71644
	],
	"./Khavar_Mianeh.svg": [
		62398,
		62398
	],
	"./Kosar.svg": [
		43498,
		43498
	],
	"./Maskan.svg": [
		87795,
		87795
	],
	"./Mehr_Eghtesad.svg": [
		11134,
		11134
	],
	"./Mehr_Iran.svg": [
		50589,
		50589
	],
	"./Melall.svg": [
		66025,
		66025
	],
	"./Mellat.svg": [
		21459,
		21459
	],
	"./Melli.svg": [
		23405,
		23405
	],
	"./Noor.svg": [
		34092,
		34092
	],
	"./Parsian.svg": [
		63490,
		63490
	],
	"./Pasargad.svg": [
		26417,
		26417
	],
	"./Postbank.svg": [
		33098,
		33098
	],
	"./Refah.svg": [
		21586,
		21586
	],
	"./Resalat.svg": [
		78528,
		78528
	],
	"./Saderat.svg": [
		53368,
		53368
	],
	"./Saman.svg": [
		78074,
		78074
	],
	"./Sanat_Madan.svg": [
		61997,
		61997
	],
	"./Sarmayeh.svg": [
		65228,
		65228
	],
	"./Sepah.svg": [
		96609,
		96609
	],
	"./Shahr.svg": [
		14190,
		14190
	],
	"./Sina.svg": [
		67909,
		67909
	],
	"./Standard_Chartered.svg": [
		7210,
		7210
	],
	"./Taavon_Eslami.svg": [
		21195,
		21195
	],
	"./Tejarat.svg": [
		21585,
		21585
	],
	"./Tosee.svg": [
		86954,
		86954
	],
	"./Tosee_Saderat.svg": [
		74609,
		74609
	],
	"./Tosee_Taavon.svg": [
		38362,
		38362
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70100;
module.exports = webpackAsyncContext;